import { Component, OnInit } from '@angular/core';
import { Code } from './../../code/panelmenu';

@Component({
  templateUrl: './panelmenu.component.html'
})
export class PanelmenuComponent implements OnInit {

  	code = Code;
  	items: any[];
	headers: any[];
	parameters: any[];
	styleHeader: any[];
	styleValue: any[];
	
    constructor() {
    }

    ngOnInit() {
    	this.items = [
            {
                label: 'File',
                icon: 'fa-file-o',
                items: [{
                        label: 'New', 
                        icon: 'fa-plus',
                        items: [
                            {label: 'Project', icon: 'fa-lock'},
                            {label: 'Other', icon: 'fa-list'}
                        ]
                    },
                    {label: 'Open', icon: 'fa-external-link'},
                    {separator: true},
                    {label: 'Quit', icon: 'fa-close'}
                ]
            },
            {
                label: 'Edit',
                icon: 'fa-edit',
                items: [
                    {label: 'Undo', icon: 'fa-mail-forward'},
                    {label: 'Redo', icon: 'fa-mail-reply'}
                ]
            },
            {
                label: 'Help',
                icon: 'fa-question',
                items: [
                    {
                        label: 'Contents',
                        icon: 'fa-bars'
                    },
                    {
                        label: 'Search', 
                        icon: 'fa-search', 
                        items: [
                            {
                                label: 'Text', 
                                items: [
                                    {
                                        label: 'Workspace'
                                    }
                                ]
                            },
                            {
                                label: 'File',
                                icon: 'fa-file',
                            }
                    ]}
                ]
            },
            {
                label: 'Actions',
                icon: 'fa-gear',
                items: [
                    {
                        label: 'Edit',
                        icon: 'fa-refresh',
                        items: [
                            {label: 'Save', icon: 'fa-save'},
                            {label: 'Update', icon: 'fa-save'},
                        ]
                    },
                    {
                        label: 'Other',
                        icon: 'fa-phone',
                        items: [
                            {label: 'Delete', icon: 'fa-minus'}
                        ]
                    }
                ]
            }
        ];
    	this.headers = [
	        {name : "名字"},
	        {name : "类型"},
	        {name : "默认"},
	        {name : "描述"}
	    ];
	    this.parameters = [
	        {name: "model",type: "array",default: "null",des: "菜单项的数组。"},
	        {name: "style",type: "string",default: "null",des: "组件的内联样式。"},
	        {name: "styleClass",type: "string",default: "null",des: "组件的样式类。"},
	        {name: "multiple",type: "boolean",default: "true",des: "是否可以同时激活多个选项卡。"}
	    ];

	    this.styleHeader = [
	    	{name : "名字"},
	        {name : "元素"}
	    ];

	    this.styleValue = [
	    	{name : "ui-panelmenu",el : "容器元素。"},
	    	{name : "ui-panelmenu-header",el : "根目录子菜单的手风琴头。"},
	    	{name : "ui-panelmenu-content",el : "根目录下的手风琴内容。"},
	    	{name : "ui-menu-list",el : "列表元素。"},
	    	{name : "ui-menuitem",el : "菜单项元素。"},
	    	{name : "ui-menuitem-text",el : "菜单项的标签。"},
	    	{name : "ui-menuitem-icon",el : "菜单项的图标。"},
	    	{name : "ui-panelmenu-icon",el : "手风琴头的箭头图标。"}
	    ];
    }

}



// WEBPACK FOOTER //
// ./src/app/view/panelmenu/panelmenu.component.ts